/**
 * Return a default branding profile.
 */
export const getSecclDefaultBranding = () => {
  return {
    backgroundColor: '#1D1739',
    backgroundColorContrast: null,
    brandColor: '#F85C88',
    ctaColor: '#0573a9',
    ctaColorContrast: null,
    footerCopyright: 'Powered by [Seccl Technology](https://seccl.tech) - 2024',
    orderExecutionPolicyUrl: null,
    windowTitle: null,
    logoBaseUrl: `https://${process.env.BUCKET_NAME}.${process.env.AWS_BUCKET_URL}/SECCL`,
    logoNodeId: '0',
  };
};
